'use client';

import { useEffect } from 'react';
import { trackFbclid } from '@/utils/fbTracking';

const FBClickTracker = () => {
  useEffect(() => {
    trackFbclid();
  }, []);

  return null;
};

export default FBClickTracker;